// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-popover {
  position: absolute;
  z-index: 100001;
  padding: 1px;
  text-align: left;
  white-space: normal;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  max-width: 800px;
  max-height: 800px;
  min-width: 100px;
  min-height: 50px;
}
.onboarding-popover.onboarding-top {
  margin-top: -10px;
}
.onboarding-popover.onboarding-right {
  margin-left: 10px;
}
.onboarding-popover.onboarding-bottom {
  margin-top: 10px;
}
.onboarding-popover.onboarding-left {
  margin-left: -10px;
}
.onboarding-popover.onboarding-centered {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}
.onboarding-arrow,
.onboarding-arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.onboarding-arrow {
  border-width: 11px;
}
.onboarding-arrow:after {
  border-width: 10px;
  content: "";
}
.onboarding-popover.onboarding-bottom .onboarding-arrow {
  top: -11px;
  left: 50%;
  margin-left: -11px;
  border-bottom-color: #cccccc;
  border-top-width: 0;
}
.onboarding-popover.onboarding-bottom .onboarding-arrow:after {
  content: " ";
  top: 1px;
  margin-left: -10px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}
.onboarding-popover.onboarding-top .onboarding-arrow {
  bottom: -11px;
  left: 50%;
  margin-left: -11px;
  border-top-color: #cccccc;
  border-bottom-width: 0;
}
.onboarding-popover.onboarding-top .onboarding-arrow:after {
  content: " ";
  bottom: 1px;
  margin-left: -10px;
  border-bottom-width: 0;
  border-top-color: #ffffff;
}
.onboarding-popover.onboarding-left .onboarding-arrow {
  top: 50%;
  right: -11px;
  margin-top: -11px;
  border-left-color: #cccccc;
  border-right-width: 0;
}
.onboarding-popover.onboarding-left .onboarding-arrow:after {
  content: " ";
  right: 1px;
  border-right-width: 0;
  border-left-color: #ffffff;
  bottom: -10px;
}
.onboarding-popover.onboarding-right .onboarding-arrow {
  top: 50%;
  left: -11px;
  margin-top: -11px;
  border-right-color: #cccccc;
  border-left-width: 0;
}
.onboarding-popover.onboarding-right .onboarding-arrow:after {
  content: " ";
  left: 1px;
  bottom: -10px;
  border-left-width: 0;
  border-right-color: #ffffff;
}
.onboarding-popover-title {
  position: relative;
  padding: 8px 14px;
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  background-color: #ffffff;
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px 5px 0 0;
  margin-right: 1em;
}
.onboarding-close-button {
  position: absolute;
  top: 2px;
  right: 5px;
  display: inline-block;
  padding: 5px;
  font-size: 110%;
  font-family: Arial, sans-serif;
}
.onboarding-close-button,
.onboarding-close-button:hover,
.onboarding-close-button:visited {
  color: #333;
  text-decoration: none;
}
.onboarding-popover-content {
  padding: 9px 14px;
}
.onboarding-button-container {
  text-align: right;
  padding: 7px;
  display: block;
  background-color: #f4f4f4;
}
.onboarding-button {
  padding: 5px 10px;
  margin: 0;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.5;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  color: #333;
  background-color: #fff;
  display: inline-block;
  text-decoration: none;
}
.onboarding-button:hover,
.onboarding-button:active {
  color: #333;
  background-color: #ebebeb;
  border-color: #adadad;
  outline: 0;
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.onboarding-overlay {
  position: fixed;
  z-index: 99999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 1000%;
  background-color: #000000;
}
.onboarding-focus {
  z-index: 100000;
}
.onboarding-step-info {
  float: left;
  text-align: left;
  display: inline-block;
  margin-top: 7px;
  font-size: 80%;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./sources/scripts/modules/Utilidades/ng-onboarding/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iDAAiD;EACjD,yCAAyC;EACzC,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;AACA;;;EAGE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,wDAAwD;EACxD,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,cAAc;EACd,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".onboarding-popover {\r\n  position: absolute;\r\n  z-index: 100001;\r\n  padding: 1px;\r\n  text-align: left;\r\n  white-space: normal;\r\n  background-color: #ffffff;\r\n  border: 1px solid #cccccc;\r\n  border-radius: 6px;\r\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\r\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\r\n  background-clip: padding-box;\r\n  max-width: 800px;\r\n  max-height: 800px;\r\n  min-width: 100px;\r\n  min-height: 50px;\r\n}\r\n.onboarding-popover.onboarding-top {\r\n  margin-top: -10px;\r\n}\r\n.onboarding-popover.onboarding-right {\r\n  margin-left: 10px;\r\n}\r\n.onboarding-popover.onboarding-bottom {\r\n  margin-top: 10px;\r\n}\r\n.onboarding-popover.onboarding-left {\r\n  margin-left: -10px;\r\n}\r\n.onboarding-popover.onboarding-centered {\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  -webkit-transform: translate(-50%, -50%);\r\n  -moz-transform: translate(-50%, -50%);\r\n  -ms-transform: translate(-50%, -50%);\r\n  -o-transform: translate(-50%, -50%);\r\n}\r\n.onboarding-arrow,\r\n.onboarding-arrow:after {\r\n  position: absolute;\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n.onboarding-arrow {\r\n  border-width: 11px;\r\n}\r\n.onboarding-arrow:after {\r\n  border-width: 10px;\r\n  content: \"\";\r\n}\r\n.onboarding-popover.onboarding-bottom .onboarding-arrow {\r\n  top: -11px;\r\n  left: 50%;\r\n  margin-left: -11px;\r\n  border-bottom-color: #cccccc;\r\n  border-top-width: 0;\r\n}\r\n.onboarding-popover.onboarding-bottom .onboarding-arrow:after {\r\n  content: \" \";\r\n  top: 1px;\r\n  margin-left: -10px;\r\n  border-top-width: 0;\r\n  border-bottom-color: #ffffff;\r\n}\r\n.onboarding-popover.onboarding-top .onboarding-arrow {\r\n  bottom: -11px;\r\n  left: 50%;\r\n  margin-left: -11px;\r\n  border-top-color: #cccccc;\r\n  border-bottom-width: 0;\r\n}\r\n.onboarding-popover.onboarding-top .onboarding-arrow:after {\r\n  content: \" \";\r\n  bottom: 1px;\r\n  margin-left: -10px;\r\n  border-bottom-width: 0;\r\n  border-top-color: #ffffff;\r\n}\r\n.onboarding-popover.onboarding-left .onboarding-arrow {\r\n  top: 50%;\r\n  right: -11px;\r\n  margin-top: -11px;\r\n  border-left-color: #cccccc;\r\n  border-right-width: 0;\r\n}\r\n.onboarding-popover.onboarding-left .onboarding-arrow:after {\r\n  content: \" \";\r\n  right: 1px;\r\n  border-right-width: 0;\r\n  border-left-color: #ffffff;\r\n  bottom: -10px;\r\n}\r\n.onboarding-popover.onboarding-right .onboarding-arrow {\r\n  top: 50%;\r\n  left: -11px;\r\n  margin-top: -11px;\r\n  border-right-color: #cccccc;\r\n  border-left-width: 0;\r\n}\r\n.onboarding-popover.onboarding-right .onboarding-arrow:after {\r\n  content: \" \";\r\n  left: 1px;\r\n  bottom: -10px;\r\n  border-left-width: 0;\r\n  border-right-color: #ffffff;\r\n}\r\n.onboarding-popover-title {\r\n  position: relative;\r\n  padding: 8px 14px;\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  line-height: 18px;\r\n  background-color: #ffffff;\r\n  border-bottom: 1px solid #ebebeb;\r\n  border-radius: 5px 5px 0 0;\r\n  margin-right: 1em;\r\n}\r\n.onboarding-close-button {\r\n  position: absolute;\r\n  top: 2px;\r\n  right: 5px;\r\n  display: inline-block;\r\n  padding: 5px;\r\n  font-size: 110%;\r\n  font-family: Arial, sans-serif;\r\n}\r\n.onboarding-close-button,\r\n.onboarding-close-button:hover,\r\n.onboarding-close-button:visited {\r\n  color: #333;\r\n  text-decoration: none;\r\n}\r\n.onboarding-popover-content {\r\n  padding: 9px 14px;\r\n}\r\n.onboarding-button-container {\r\n  text-align: right;\r\n  padding: 7px;\r\n  display: block;\r\n  background-color: #f4f4f4;\r\n}\r\n.onboarding-button {\r\n  padding: 5px 10px;\r\n  margin: 0;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  line-height: 1.5;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n  cursor: pointer;\r\n  background-image: none;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  -o-user-select: none;\r\n  color: #333;\r\n  background-color: #fff;\r\n  display: inline-block;\r\n  text-decoration: none;\r\n}\r\n.onboarding-button:hover,\r\n.onboarding-button:active {\r\n  color: #333;\r\n  background-color: #ebebeb;\r\n  border-color: #adadad;\r\n  outline: 0;\r\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n}\r\n.onboarding-overlay {\r\n  position: fixed;\r\n  z-index: 99999;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 1000%;\r\n  background-color: #000000;\r\n}\r\n.onboarding-focus {\r\n  z-index: 100000;\r\n}\r\n.onboarding-step-info {\r\n  float: left;\r\n  text-align: left;\r\n  display: inline-block;\r\n  margin-top: 7px;\r\n  font-size: 80%;\r\n  font-style: italic;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
